<template>
	<div class="report-left-list consultant-workload">
		<div class="each-turn consultant-w">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top-start="relation.fullName">{{relation.fullName | truncate(15)}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn co-w-thone-sap">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i>{{relation.sap}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn co-w-thone-country">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">
					<i v-tooltip.top="relation.customer">{{relation.customer | truncate(11)}}</i>
				</p>
			</div>
		</div>
		<div class="each-turn co-w-thone">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">{{relation.oeShortName}}</p>
			</div>
		</div>
		<div class="each-turn co-w-thone">
			<div class="master-table-text right-table-header alloc-value">
				<p class="left-td">{{relation.qEmployment}}%</p>
			</div>
		</div>
	</div>
</template>

<script>
    import filters from "../../../../mixins/filters";

    export default {
        name: "BenchRelation",
        props: ["relation"],
        mixins: [filters],
    }
</script>

<style scoped>
</style>
